import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <defs>
      <linearGradient id="loaderGradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#a78bfa" />
        <stop offset="100%" stopColor="#c4b5fd" />
      </linearGradient>
    </defs>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M 25.5417 61 L 37.116699999999994 30.3 L 42.116699999999994 30.3 L 53.6917 61 L 48.6917 61 L 45.29837752442997 52 L 33.93502247557003 52 L 30.5417 61 Z M 35.82020162866449 47 L 43.413198371335504 47 L 37.49373583061889 31.3 L 41.7396641693811 31.3 Z"
          fill="url(#loaderGradient)"
        />
      </g>
      <path
        stroke="url(#loaderGradient)"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
